module.exports = __webpack_public_path__ + "img/users_management.5b125077.svg";